'use client';

function getEmphasis({
  emphasis: emphasisProp,
  variant
}) {
  if (variant === "default") {
    if (emphasisProp === "high") return "medium";
    if (emphasisProp === void 0) return "medium";
    return emphasisProp;
  }
  if (variant === "primary") return "high";
  if (emphasisProp === void 0) return "high";
  return emphasisProp;
}
export {
  getEmphasis
};
